(() => {
  if (window.mmRelatedProductsHoverImagesBound) return;
  window.mmRelatedProductsHoverImagesBound = true;

  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener(
    'pointerover',
    (event) => {
      if (!supportsHover.matches) return;

      const card = event.target.closest('[data-mm-related-card]');
      if (!card) return;

      const secondaryImage = card.querySelector('[data-secondary-src]');
      if (!secondaryImage || secondaryImage.dataset.secondaryLoaded === 'true') return;

      secondaryImage.dataset.secondaryLoaded = 'true';
      secondaryImage.addEventListener('load', () => card.classList.add('is-secondary-ready'), { once: true });

      if (secondaryImage.dataset.secondarySrcset) {
        secondaryImage.srcset = secondaryImage.dataset.secondarySrcset;
      }
      secondaryImage.src = secondaryImage.dataset.secondarySrc;

      if (secondaryImage.complete && secondaryImage.naturalWidth > 32) {
        card.classList.add('is-secondary-ready');
      }
    },
    { passive: true }
  );
})();
